import type { ComponentProps } from 'react'
import { Input } from '@/components/ui/input'

/**
 * A box for searching or filtering a list: search text, a min/max range. Plain text boxes are
 * deprecated (USA-1580); this is one of the named places a box is still the right control. Editing
 * a saved value uses POInlineEditableField or InlineFieldGroup instead.
 *
 * `bare` drops the shared box styling for a search field that draws its own (a combobox shell).
 */
export function SearchInput({ bare = false, ...props }: ComponentProps<'input'> & { bare?: boolean }) {
  return bare ? <input {...props} /> : <Input {...props} />
}
